/**
 * Catálogo sugerido de `kind` para pines de lista CAD (v1).
 * El API acepta cualquier string ≤ 40; desconocidos caen a `custom`.
 */

export const CAD_PROJECT_PIN_KIND_CUSTOM = 'custom';

/** @type {{ id: string, label: string }[]} */
export const CAD_PROJECT_PIN_KINDS = [
  { id: 'entrance', label: 'Ingreso' },
  { id: 'security', label: 'Seguridad' },
  { id: 'green', label: 'Espacio verde' },
  { id: 'amenity', label: 'Amenity' },
  { id: CAD_PROJECT_PIN_KIND_CUSTOM, label: 'Otro' },
];

export const CAD_PROJECT_PIN_KIND_IDS = CAD_PROJECT_PIN_KINDS.map((row) => row.id);

/** @type {Record<string, string>} */
export const CAD_PROJECT_PIN_KIND_LABELS = CAD_PROJECT_PIN_KINDS.reduce((acc, row) => {
  acc[row.id] = row.label;
  return acc;
}, {});

/**
 * @param {string|null|undefined} kind
 * @returns {string}
 */
export function resolveCadProjectPinKind(kind) {
  const key = String(kind || '').trim();
  if (key && CAD_PROJECT_PIN_KIND_IDS.includes(key)) return key;
  return CAD_PROJECT_PIN_KIND_CUSTOM;
}

/**
 * @param {string|null|undefined} kind
 * @returns {string}
 */
export function cadProjectPinKindLabel(kind) {
  const resolved = resolveCadProjectPinKind(kind);
  return CAD_PROJECT_PIN_KIND_LABELS[resolved] || CAD_PROJECT_PIN_KIND_LABELS[CAD_PROJECT_PIN_KIND_CUSTOM];
}
